// extracted by mini-css-extract-plugin
export default {"wrapper":"Exr9RqTSEFnXV8UdJO57","withBgColor":"GUFGd8XpGXx6lGnyVsE7","title":"xYkgncJAihIp659hdyum","subtitle":"tHhAOBUqgNTRCmiWl9ux"};